import { request } from '../request'

/** 登录 */
export function loginByPhone(data) {
  return request('account/loginByPhone', data)
}

/** 超管切换用户登录 */
export function switchUser(data) {
  return request('account/switchUser', data)
}

/** 修改密码 */
export function updatePassword(data) {
  return request('account/updatePassword', data)
}

/** 重置用户密码 */
export function resetUserPwd(data) {
  return request('account/resetUserPwd', data)
}

/** 获取用户信息 */
export function getUserInfo(data) {
  return request('account/getUserInfo', data)
}

/** 律所列表 */
export function listLawFirm(data) {
  return request('account/listLawFirm', data)
}

/** 新增/更新律所 */
export function upsertLawFirm(data) {
  return request('account/upsertLawFirm', data)
}

/** 删除律所 */
export function delLawFirm(data) {
  return request('account/delLawFirm', data)
}

/** 更新律所Logo */
export function updateLawFirmLogoUrl(data) {
  return request('account/updateLawFirmLogoUrl', data)
}

/** 用户列表 */
export function listUser(data) {
  return request('account/listUser', data)
}

/** 新增/更新用户 */
export function upsertUser(data) {
  return request('account/upsertUser', data)
}

/** 转所：只更新用户账号和手机号 */
export function transferUser(data) {
  return request('account/transferUser', data)
}

/** 删除用户 */
export function delUser(data) {
  return request('account/delUser', data)
}

/** 单独更新用户标签文本 */
export function updateUserLabel(data) {
  return request('account/updateUserLabel', data)
}

/** 更新用户数据权限标签 */
export function updateUserTag(data) {
  return request('account/updateUserTag', data)
}

/** 标签列表 */
export function listTag(data) {
  return request('account/listTag', data)
}

/** 新增/更新标签 */
export function upsertTag(data) {
  return request('account/upsertTag', data)
}

/** 删除标签 */
export function delTag(data) {
  return request('account/delTag', data)
}

/** 委托单位列表（不缓存，数据量大直接请求） */
export function listEntrustUnit(data) {
  return request('account/listEntrustUnit', data)
}
export const clearEntrustUnitCache = () => {} // 保留接口兼容，无需操作

/** 委托单位列表V1（用于委托单位管理页面，不缓存，支持分页和搜索） */
export function listEntrustUnitV1(data) {
  return request('account/listEntrustUnitV1', data)
}

/** 新增/更新委托单位 */
export function upsertEntrustUnit(data) {
  return request('account/upsertEntrustUnit', data)
}

/** 删除委托单位 */
export function delEntrustUnit(data) {
  return request('account/delEntrustUnit', data)
}

/** 委托人列表（不缓存，数据量大直接请求） */
export function listEntrustPerson(data) {
  return request('account/listEntrustPerson', data)
}
export const clearEntrustPersonCache = () => {} // 保留接口兼容，无需操作

/** 委托人列表V1（用于委托人员管理页面，不缓存，支持分页和搜索） */
export function listEntrustPersonV1(data) {
  return request('account/listEntrustPersonV1', data)
}

/** 新增/更新委托人 */
export function upsertEntrustPerson(data) {
  return request('account/upsertEntrustPerson', data)
}

/** 删除委托人 */
export function delEntrustPerson(data) {
  return request('account/delEntrustPerson', data)
}

/** 顾问单位列表 */
export function listConsultantUnit(data) {
  return request('account/listConsultantUnit', data)
}

/** 新增/更新顾问单位 */
export function upsertConsultantUnit(data) {
  return request('account/upsertConsultantUnit', data)
}

/** 删除顾问单位 */
export function delConsultantUnit(data) {
  return request('account/delConsultantUnit', data)
}

/** 获取图形验证码 */
export function getGraphicVercode(data) {
  return request('account/getGraphicVercode', data)
}

/** 律师列表（通讯录） */
export function listLawyer(data) {
  return request('account/listLawyer', data)
}

/** 用户处理日志列表 */
export function listUserDealLog(data) {
  return request('account/listUserDealLog', data)
}

/** 新增用户处理日志 */
export function addUserDealLog(data) {
  return request('account/addUserDealLog', data)
}

/** 奖惩记录列表 */
export function listDealLog(data) {
  return request('account/listDealLog', data)
}

/** 删除奖惩记录 */
export function delDealLog(data) {
  return request('account/delDealLog', data)
}

/** 新增/更新奖惩记录 */
export function upsertDealLog(data) {
  return request('account/upsertDealLog', data)
}

/** 批量重置弱密码 */
export function batchResetWeakPassword(data) {
  return request('account/batchResetWeakPassword', data)
}
